var SepaPayment = (function () {

    function setBankName(value) {
        var queryParams = {
            bic: value
        };

        $.ajax({
            type: 'GET',
            url: "/payment/sepa",
            data: queryParams
        }).done(function (data) {
            $("#sepaBankName").html(data);
            $("#inputBankName").val(data);
            $("#sepaBankNamePlaceholder").hide();
        }).fail(function () {
            $("#sepaBankName").html("");
            $("#inputBankName").val("");
            $("#sepaBankNamePlaceholder").show();
        });
    }

    function initialize() {
        var sepaBicInput = $("#sepaBic");
        var sepaBicValue = sepaBicInput.val();
        if (sepaBicValue) {
            setBankName(sepaBicValue);
        }

        sepaBicInput.on("blur", function () {
            setBankName(this.value);
        });
    }

    return {
        initialize: initialize
    }

})();


$(document).ready(function () {
    SepaPayment.initialize();
});